<template>
  <template v-if="column.field != null || column.type === 'progressbar'">
    <div
      v-if="column.type === 'title' && dossier[column.field]"
      class="flex-column flex dark:bg-slate-700 dark:text-white"
    >
      <DossierTitleElement
        :column="column"
        :dossier="dossier"
        :display-sub-task-button="indexcolumn === 0"
        @toggle-tasks="$emit('toggleTasks', { columnId: null })"
      />
    </div>
    <div v-else-if="column.type === 'link' && dossier[column.field]" class="">
      <DashboardLink :column="column" :dossier="dossier" />
    </div>
    <div v-else-if="column.type === 'progressbar' && isShowable()" class="px-1">
      <TaskProgressBar
        :column="column"
        :dossier="dossier"
        @toggle-tasks="$emit('toggleTasks', $event)"
      />
    </div>
    <div
      v-else-if="column.type === 'date'"
      class="truncate px-1 dark:text-white"
    >
      <DateComponent :column="column" :dossier="dossier" />
    </div>
    <div
      v-else-if="column.type === 'text'"
      class="capitalize-first truncate px-1 dark:text-white"
      v-text="dossier[column.field] === '#######' ? '' : dossier[column.field]"
    />
    <div
      v-else-if="
        column.type === 'avatar' &&
        (dossier[column.field] || column.field === 'dossier#funeralHome#logo')
      "
      class="flex justify-center px-1"
    >
      <UserAvatarPopover
        v-if="
          [
            'responsable_ceremony_id',
            'responsable_id',
            'master_ceremony_id',
            'agent_id'
          ].includes(column.field)
        "
        :user-id="dossier[column.field]"
      />
      <FuneralHomeAvatar
        v-else-if="['funeral_home_id'].includes(column.field)"
        :id="dossier[column.field]"
      />
      <FuneralHomeAvatar
        v-else-if="column.field === 'dossier#funeralHome#logo'"
        :id="dossier.funeral_home_id"
      />
      <img
        v-else
        class="mx-auto h-8 w-8 rounded-full shadow-md ring-2 ring-white"
        :src="dossier[column.field]"
        alt="##"
      />
    </div>
    <div
      v-else-if="column.type === 'label' && dossier[column.field] != null"
      class="truncate px-1 dark:text-white"
    >
      <template v-if="column.field === 'dossier#properties#publish_on_website'">
        <FontAwesomeIcon
          v-if="dossier[column.field] === '1'"
          :icon="['fal', 'cloud-check']"
          class="text-green-500"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'cloud-slash']"
          class="text-gray-300"
        />
      </template>
      <BaseLabel
        v-else
        :icon="column.field ? column.field.icon : null"
        :content="
          column.field
            ? typeof dossier[column.field] === 'string'
              ? dossier[column.field]
              : dossier[column.field]?.value
            : null
        "
        :color="column.field ? dossier[column.field]?.color : null"
      />
    </div>
    <ModalComponent
      v-else-if="column.type === 'modal_infos'"
      :column="column"
      :dossier="dossier"
      :block-placement="
        indexDossier < dossierList.length - 3 ? 'bottom' : 'top'
      "
      :line-placement="
        indexcolumn < dossierMetadata.length - 2 ? 'center' : 'left'
      "
    />
    <div v-else-if="column.type === 'task' && filterdTask" class="px-1">
      <TaskComponent :task="filterdTask" />
    </div>
    <div v-else-if="column.type === 'partner'" class="px-1">
      <PartnerColumnComponent
        :column="column"
        :dossier="dossier"
        :field="column.field"
      />
    </div>
  </template>
</template>
<script>
import TaskComponent from '@c/TaskComponent'
import TaskProgressBar from '@c/Dashboard/Content/Dossier/components/Body/components/TaskProgressBar'
import DossierTitleElement from '@c/Dashboard/Content/Dossier/components/Body/components/DossierTitleElement'
import { mapGetters } from 'vuex'
import DashboardLink from '@c/Dashboard/Content/Dossier/components/Body/DashboardLink'
import BaseLabel from '@c/addf-package/components/BaseLabel/BaseLabel.vue'
import PartnerColumnComponent from '@c/Dashboard/Content/Dossier/components/Body/PartnerColumnComponent.vue'
import DateComponent from '@c/Dashboard/Content/Dossier/components/Body/DateComponent.vue'
import ModalComponent from '@c/Dashboard/Content/Dossier/components/Body/ModalComponent.vue'
import UserAvatarPopover from '@c/Avatar/Popover/UserAvatarPopover.vue'
import FuneralHomeAvatar from '@c/Avatar/FuneralHomeAvatar.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DashBoardRowElement',
  components: {
    FontAwesomeIcon,
    FuneralHomeAvatar,
    UserAvatarPopover,
    ModalComponent,
    DateComponent,
    PartnerColumnComponent,
    BaseLabel,
    DashboardLink,
    DossierTitleElement,
    TaskProgressBar,
    TaskComponent
  },
  props: {
    column: {
      type: Object,
      required: true
    },
    dossier: {
      type: Object,
      required: true
    },
    indexDossier: {
      type: Number,
      required: true
    },
    indexcolumn: {
      type: Number,
      required: true
    },
    showTasks: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['toggleTasks'],
  computed: {
    ...mapGetters({
      dossierList: 'dossier/getDossierIndex',
      dossierMetadata: 'dossier/getDossierMetadata',
      getUsers: 'metadata/getAllUserMetadata'
    }),
    filterdTask() {
      return this.dossier.tasks?.find((task) => {
        return task.task_id === this.column.field
      })
    }
  },
  methods: {
    isShowable() {
      const fieldIds = Array.isArray(this.column.field)
        ? this.column.field
        : [this.column.field || 'ALL']

      if (fieldIds.includes('ALL')) {
        return this.dossier.tasks.length > 0
      }

      return fieldIds.some(
        (id) => this.dossier.tasks_progress?.[id]?.tasks?.length > 0
      )
    }
  }
}
</script>
